import { render, staticRenderFns } from "./SFooter.vue?vue&type=template&id=2ed7e652&scoped=true&"
import script from "./SFooter.vue?vue&type=script&lang=js&"
export * from "./SFooter.vue?vue&type=script&lang=js&"
import style0 from "./SFooter.vue?vue&type=style&index=0&id=2ed7e652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed7e652",
  null
  
)

export default component.exports